import script from "./sjddList.vue?vue&type=script&setup=true&lang=js"
export * from "./sjddList.vue?vue&type=script&setup=true&lang=js"

import "./sjddList.vue?vue&type=style&index=0&id=3b5c91d7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b5c91d7"]])

export default __exports__